module.exports = __webpack_public_path__ + "static/media/ai.1334111c.svg";